import React from 'react';
import { StyleSheet, View } from 'react-native';
import BarcodeCameraView from '../../components/camera/BarcodeCameraView';

import { Button } from '../../components';
import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const PendingStockScannerView = ({
	cameraPermission,
	requestCameraPermission,
	onBarcodeScanned,
	prompt,
	isLookingUpProduct,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.scannerContainer}>
			{!cameraPermission ? (
				<View style={styles.scannerFallback}>
					<Text style={styles.scannerFallbackText}>Requesting camera permission</Text>
				</View>
			) : !cameraPermission.granted ? (
				<View style={styles.scannerFallback}>
					<Text style={styles.scannerFallbackText}>Camera access is required to scan barcodes.</Text>
					<Button
						label="Grant permission"
						onPress={requestCameraPermission}
					/>
				</View>
			) : (
				<>
					<BarcodeCameraView
						onBarcodeScanned={onBarcodeScanned}
						style={StyleSheet.absoluteFillObject}
					/>
					<View style={styles.scannerOverlay}>
						<Text style={styles.scannerText}>{prompt}</Text>
						{isLookingUpProduct && (
							<Text style={styles.scannerText}>Looking up product...</Text>
						)}
					</View>
				</>
			)}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	scannerContainer: {
		height: 360,
		backgroundColor: colors.canvas,
		overflow: 'hidden',
	},
	scannerFallback: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		gap: space.md,
		padding: space.lg,
	},
	scannerFallbackText: {
		...type.bodySmall,
		color: colors.text,
		textAlign: 'center',
	},
	scannerOverlay: {
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		padding: 14,
		gap: space.sm,
		backgroundColor: colors.overlay,
	},
	// Text sits on the dark camera overlay in every theme.
	scannerText: {
		...type.bodySmall,
		color: colors.onPrimary,
	},
});

export default PendingStockScannerView;
